(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calmsky-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var el = document.querySelector('[data-announcement-countdown]');
    var container = document.querySelector('[data-announcement-end]');
    if (!el || !container) return;

    var endDateStr = container.getAttribute('data-announcement-end');
    var endTime = new Date(endDateStr).getTime();
    // Bad or missing date input → bail, keep the server-rendered fallback
    // text ('2d 14h 32m 47s') visible. Won't be accurate but won't crash.
    if (isNaN(endTime)) return;

    function pad(n) { return n < 10 ? '0' + n : n; }

    function render() {
      var diff = endTime - Date.now();

      if (diff <= 0) {
        // Sale ended. Hide the entire banner rather than showing zeros —
        // safety net only. Primary end-of-sale action is toggling
        // "Show banner" off in Shopify Admin.
        container.style.display = 'none';
        return;
      }

      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);

      el.textContent = days + 'd ' + hours + 'h ' + pad(mins) + 'm ' + pad(secs) + 's';
    }

    render();
    // Update every second so the seconds counter ticks visibly. Text-content
    // swap only (no layout recalc), so CPU/battery cost is negligible.
    setInterval(render, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmsky-buybox"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bars = document.querySelectorAll('[data-calmsky-sticky-bar]');
    if (bars.length && 'IntersectionObserver' in window) {
      bars.forEach(function (bar) {
        var section = bar.closest('section');
        if (!section) return;
        var mainCta = section.querySelector('[data-calmsky-add-to-cart], [data-calmsky-add-to-cart-preview]');
        if (!mainCta) return;

        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              bar.classList.remove('is-visible');
              bar.setAttribute('aria-hidden', 'true');
            } else {
              bar.classList.add('is-visible');
              bar.setAttribute('aria-hidden', 'false');
            }
          });
        }, { rootMargin: '-10% 0px -10% 0px', threshold: 0 });

        observer.observe(mainCta);
      });
    }

    // Quantity stepper — cap at min 1, integers only.
    var steppers = document.querySelectorAll('.calmsky-buybox__qty-stepper');
    steppers.forEach(function (stepper) {
      var input = stepper.querySelector('[data-calmsky-qty-input]');
      var dec = stepper.querySelector('[data-calmsky-qty-decrease]');
      var inc = stepper.querySelector('[data-calmsky-qty-increase]');
      if (!input || !dec || !inc) return;

      function clamp() {
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 1) v = 1;
        input.value = v;
      }

      dec.addEventListener('click', function () {
        var v = parseInt(input.value, 10);
        if (isNaN(v)) v = 1;
        input.value = Math.max(1, v - 1);
      });

      inc.addEventListener('click', function () {
        var v = parseInt(input.value, 10);
        if (isNaN(v)) v = 1;
        input.value = v + 1;
      });

      input.addEventListener('input', clamp);
      input.addEventListener('blur', clamp);
    });

    // Gallery — click + arrow-key + touch-swipe navigation over the 5-thumb tablist.
    (function () {
      var main = document.querySelector('[data-calmsky-buybox-main]');
      var tabs = Array.prototype.slice.call(document.querySelectorAll('[data-calmsky-buybox-thumb]'));
      var dots = Array.prototype.slice.call(document.querySelectorAll('[data-gallery-dot]'));
      if (!main || !tabs.length) return;

      var currentIndex = 0;

      function select(idx) {
        if (idx < 0 || idx >= tabs.length) return;
        currentIndex = idx;
        var tab = tabs[idx];
        var src = tab.getAttribute('data-src');
        var alt = tab.getAttribute('data-alt') || '';
        if (src) {
          main.setAttribute('src', src);
          main.setAttribute('alt', alt);
        }
        tabs.forEach(function (t, i) {
          var isActive = i === idx;
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
          t.setAttribute('tabindex', isActive ? '0' : '-1');
          t.classList.toggle('calmsky-buybox__thumb--selected', isActive);
        });
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      }

      function focusAndSelect(idx) {
        select(idx);
        tabs[idx].focus();
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i); });
        tab.addEventListener('keydown', function (e) {
          switch (e.key) {
            case 'ArrowRight':
              e.preventDefault();
              focusAndSelect((i + 1) % tabs.length);
              break;
            case 'ArrowLeft':
              e.preventDefault();
              focusAndSelect((i - 1 + tabs.length) % tabs.length);
              break;
            case 'Home':
              e.preventDefault();
              focusAndSelect(0);
              break;
            case 'End':
              e.preventDefault();
              focusAndSelect(tabs.length - 1);
              break;
          }
        });
      });

      // Touch swipe on the main image container.
      // Only advances when horizontal delta > 40px AND horizontal exceeds
      // vertical (so vertical scroll is preserved).
      var imgContainer = main.parentElement;
      if (imgContainer && 'ontouchstart' in window) {
        var startX = 0, startY = 0, endX = 0, endY = 0, tracking = false;
        imgContainer.addEventListener('touchstart', function (e) {
          if (!e.touches.length) return;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          endX = startX;
          endY = startY;
          tracking = true;
        }, { passive: true });
        imgContainer.addEventListener('touchmove', function (e) {
          if (!tracking || !e.touches.length) return;
          endX = e.touches[0].clientX;
          endY = e.touches[0].clientY;
        }, { passive: true });
        imgContainer.addEventListener('touchend', function () {
          if (!tracking) return;
          tracking = false;
          var dx = endX - startX;
          var dy = endY - startY;
          if (Math.abs(dx) < 40) return;                  // ignore taps + tiny drags
          if (Math.abs(dy) > Math.abs(dx)) return;        // vertical scroll — don't hijack
          if (dx < 0) {
            select((currentIndex + 1) % tabs.length);      // swipe left → next
          } else {
            select((currentIndex - 1 + tabs.length) % tabs.length);  // swipe right → prev
          }
        });
      }
    })();

    // Variant picker — SKU radio swap (Refinement AA + currency migration).
    // Prices are pre-formatted server-side via Shopify's `money` filter, so
    // JS reads formatted strings from data-*-formatted attributes rather
    // than computing currency client-side. This works with Shopify Markets
    // auto-conversion out of the box.
    (function () {
      var radios = document.querySelectorAll('[data-calmsky-variant-radio]');
      if (!radios.length) return;

      var priceEl = document.querySelector('[data-calmsky-price-current]');
      var priceWasEl = document.querySelector('[data-calmsky-price-was]');
      var savingsEl = document.querySelector('[data-calmsky-price-savings]');
      var qtyWrap = document.querySelector('[data-calmsky-qty-wrap]');
      var qtyInput = document.querySelector('[data-calmsky-qty-input]');
      var variantIdInput = document.querySelector('[data-calmsky-variant-id]');
      var stickyPriceEl = document.querySelector('[data-calmsky-sticky-price]');

      function applyVariant(radio) {
        var priceStr = radio.getAttribute('data-price-formatted') || '';
        var compareStr = radio.getAttribute('data-compare-formatted') || '';
        var isDigital = radio.getAttribute('data-digital') === 'true';
        var variantId = radio.getAttribute('data-variant-id') || '';

        if (priceEl) priceEl.textContent = priceStr;

        if (priceWasEl) {
          // Show strikethrough only when a distinct compare-at exists.
          if (compareStr && compareStr !== priceStr) {
            priceWasEl.textContent = compareStr;
            priceWasEl.style.display = '';
          } else {
            priceWasEl.textContent = '';
            priceWasEl.style.display = 'none';
          }
        }

        if (savingsEl) {
          // Read the discount percentage directly from the radio's
          // data-discount-pct attribute. This is the single source of truth
          // shared with the per-radio badges to avoid rounding-drift mismatch.
          var pct = radio.getAttribute('data-discount-pct');
          if (pct) {
            savingsEl.textContent = '−' + pct + '% OFF';
            savingsEl.style.display = '';
          } else {
            savingsEl.textContent = '';
            savingsEl.style.display = 'none';
          }
        }

        if (qtyWrap) {
          qtyWrap.style.display = isDigital ? 'none' : '';
          if (isDigital && qtyInput) qtyInput.value = 1;
        }

        if (variantIdInput) variantIdInput.value = variantId;

        if (stickyPriceEl) stickyPriceEl.textContent = priceStr;

        Array.prototype.forEach.call(radios, function (r) {
          var label = r.closest('.calmsky-buybox__variant-option');
          if (!label) return;
          label.classList.toggle('calmsky-buybox__variant-option--checked', r.checked);
        });
      }

      var initial = Array.prototype.filter.call(radios, function (r) { return r.checked; })[0];
      if (initial) applyVariant(initial);

      Array.prototype.forEach.call(radios, function (r) {
        r.addEventListener('change', function () {
          if (r.checked) applyVariant(r);
        });
      });
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmsky-landing-buybox"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bars = document.querySelectorAll('[data-calmsky-sticky-bar]');
    if (bars.length && 'IntersectionObserver' in window) {
      bars.forEach(function (bar) {
        var section = bar.closest('section');
        if (!section) return;
        var mainCta = section.querySelector('[data-calmsky-add-to-cart], [data-calmsky-add-to-cart-preview]');
        if (!mainCta) return;

        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              bar.classList.remove('is-visible');
              bar.setAttribute('aria-hidden', 'true');
            } else {
              bar.classList.add('is-visible');
              bar.setAttribute('aria-hidden', 'false');
            }
          });
        }, { rootMargin: '-10% 0px -10% 0px', threshold: 0 });

        observer.observe(mainCta);
      });
    }

    // Quantity stepper — cap at min 1, integers only.
    var steppers = document.querySelectorAll('.calmsky-landing-buybox__qty-stepper');
    steppers.forEach(function (stepper) {
      var input = stepper.querySelector('[data-calmsky-qty-input]');
      var dec = stepper.querySelector('[data-calmsky-qty-decrease]');
      var inc = stepper.querySelector('[data-calmsky-qty-increase]');
      if (!input || !dec || !inc) return;

      function clamp() {
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 1) v = 1;
        input.value = v;
      }

      dec.addEventListener('click', function () {
        var v = parseInt(input.value, 10);
        if (isNaN(v)) v = 1;
        input.value = Math.max(1, v - 1);
      });

      inc.addEventListener('click', function () {
        var v = parseInt(input.value, 10);
        if (isNaN(v)) v = 1;
        input.value = v + 1;
      });

      input.addEventListener('input', clamp);
      input.addEventListener('blur', clamp);
    });

    // Gallery — click + arrow-key + touch-swipe navigation over the 5-thumb tablist.
    (function () {
      var main = document.querySelector('[data-calmsky-landing-buybox-main]');
      var tabs = Array.prototype.slice.call(document.querySelectorAll('[data-calmsky-landing-buybox-thumb]'));
      var dots = Array.prototype.slice.call(document.querySelectorAll('[data-landing-gallery-dot]'));
      if (!main || !tabs.length) return;

      var currentIndex = 0;

      function select(idx) {
        if (idx < 0 || idx >= tabs.length) return;
        currentIndex = idx;
        var tab = tabs[idx];
        var src = tab.getAttribute('data-src');
        var alt = tab.getAttribute('data-alt') || '';
        if (src) {
          main.setAttribute('src', src);
          main.setAttribute('alt', alt);
        }
        tabs.forEach(function (t, i) {
          var isActive = i === idx;
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
          t.setAttribute('tabindex', isActive ? '0' : '-1');
          t.classList.toggle('calmsky-landing-buybox__thumb--selected', isActive);
        });
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      }

      function focusAndSelect(idx) {
        select(idx);
        tabs[idx].focus();
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i); });
        tab.addEventListener('keydown', function (e) {
          switch (e.key) {
            case 'ArrowRight':
              e.preventDefault();
              focusAndSelect((i + 1) % tabs.length);
              break;
            case 'ArrowLeft':
              e.preventDefault();
              focusAndSelect((i - 1 + tabs.length) % tabs.length);
              break;
            case 'Home':
              e.preventDefault();
              focusAndSelect(0);
              break;
            case 'End':
              e.preventDefault();
              focusAndSelect(tabs.length - 1);
              break;
          }
        });
      });

      // Touch swipe on the main image container.
      // Only advances when horizontal delta > 40px AND horizontal exceeds
      // vertical (so vertical scroll is preserved).
      var imgContainer = main.parentElement;
      if (imgContainer && 'ontouchstart' in window) {
        var startX = 0, startY = 0, endX = 0, endY = 0, tracking = false;
        imgContainer.addEventListener('touchstart', function (e) {
          if (!e.touches.length) return;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          endX = startX;
          endY = startY;
          tracking = true;
        }, { passive: true });
        imgContainer.addEventListener('touchmove', function (e) {
          if (!tracking || !e.touches.length) return;
          endX = e.touches[0].clientX;
          endY = e.touches[0].clientY;
        }, { passive: true });
        imgContainer.addEventListener('touchend', function () {
          if (!tracking) return;
          tracking = false;
          var dx = endX - startX;
          var dy = endY - startY;
          if (Math.abs(dx) < 40) return;                  // ignore taps + tiny drags
          if (Math.abs(dy) > Math.abs(dx)) return;        // vertical scroll — don't hijack
          if (dx < 0) {
            select((currentIndex + 1) % tabs.length);      // swipe left → next
          } else {
            select((currentIndex - 1 + tabs.length) % tabs.length);  // swipe right → prev
          }
        });
      }
    })();

    // Variant picker — SKU radio swap (Refinement AA + currency migration).
    // Prices are pre-formatted server-side via Shopify's `money` filter, so
    // JS reads formatted strings from data-*-formatted attributes rather
    // than computing currency client-side. This works with Shopify Markets
    // auto-conversion out of the box.
    (function () {
      var radios = document.querySelectorAll('[data-calmsky-variant-radio]');
      if (!radios.length) return;

      var priceEl = document.querySelector('[data-calmsky-price-current]');
      var priceWasEl = document.querySelector('[data-calmsky-price-was]');
      var savingsEl = document.querySelector('[data-calmsky-price-savings]');
      var qtyWrap = document.querySelector('[data-calmsky-qty-wrap]');
      var qtyInput = document.querySelector('[data-calmsky-qty-input]');
      var variantIdInput = document.querySelector('[data-calmsky-variant-id]');
      var stickyPriceEl = document.querySelector('[data-calmsky-sticky-price]');

      function applyVariant(radio) {
        var priceStr = radio.getAttribute('data-price-formatted') || '';
        var compareStr = radio.getAttribute('data-compare-formatted') || '';
        var isDigital = radio.getAttribute('data-digital') === 'true';
        var variantId = radio.getAttribute('data-variant-id') || '';

        if (priceEl) priceEl.textContent = priceStr;

        if (priceWasEl) {
          // Show strikethrough only when a distinct compare-at exists.
          if (compareStr && compareStr !== priceStr) {
            priceWasEl.textContent = compareStr;
            priceWasEl.style.display = '';
          } else {
            priceWasEl.textContent = '';
            priceWasEl.style.display = 'none';
          }
        }

        if (savingsEl) {
          // Read the discount percentage directly from the radio's
          // data-discount-pct attribute. This is the single source of truth
          // shared with the per-radio badges to avoid rounding-drift mismatch.
          var pct = radio.getAttribute('data-discount-pct');
          if (pct) {
            savingsEl.textContent = '−' + pct + '% OFF';
            savingsEl.style.display = '';
          } else {
            savingsEl.textContent = '';
            savingsEl.style.display = 'none';
          }
        }

        if (qtyWrap) {
          qtyWrap.style.display = isDigital ? 'none' : '';
          if (isDigital && qtyInput) qtyInput.value = 1;
        }

        if (variantIdInput) variantIdInput.value = variantId;

        if (stickyPriceEl) stickyPriceEl.textContent = priceStr;

        Array.prototype.forEach.call(radios, function (r) {
          var label = r.closest('.calmsky-landing-buybox__variant-option');
          if (!label) return;
          label.classList.toggle('calmsky-landing-buybox__variant-option--checked', r.checked);
        });
      }

      var initial = Array.prototype.filter.call(radios, function (r) { return r.checked; })[0];
      if (initial) applyVariant(initial);

      Array.prototype.forEach.call(radios, function (r) {
        r.addEventListener('change', function () {
          if (r.checked) applyVariant(r);
        });
      });
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmsky-landing-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var track = document.querySelector('[data-reviews-track]');
    var dotsContainer = document.querySelector('[data-reviews-dots]');
    if (!track || !dotsContainer) return;

    var cards = track.querySelectorAll('[data-reviews-card]');
    var dots  = dotsContainer.querySelectorAll('[data-reviews-dot]');
    if (cards.length === 0 || dots.length === 0) return;

    function setActive(index) {
      dots.forEach(function (dot, i) {
        var isActive = i === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    // Observe which card is most visible inside the horizontal scroller.
    // threshold: 0.6 means the card must be >=60% visible to be considered
    // "the active one". Prevents flicker between two half-visible cards.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            var index = Array.prototype.indexOf.call(cards, entry.target);
            if (index !== -1) setActive(index);
          }
        });
      }, {
        root: track,
        threshold: [0.6]
      });
      cards.forEach(function (card) { observer.observe(card); });
    }

    // Clicking a dot snaps the scroll container to the corresponding card.
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var target = cards[i];
        if (!target) return;
        // Use scrollIntoView with 'inline: start' to align the card to the
        // scroll container's start edge — matches the CSS scroll-snap-align
        // declaration on `.calmsky-landing-reviews__card`.
        target.scrollIntoView({
          behavior: 'smooth',
          inline: 'start',
          block: 'nearest'
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmsky-landing-sticky"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var banner = document.querySelector('[data-landing-sticky]');
    if (!banner) return;
    if (!('IntersectionObserver' in window)) return;

    // Selectors: read from data-* attributes if present, else fall back to
    // the legacy How-It-Works / anxious-flyer hardcoded pair. Empty strings
    // count as "not configured" (leading whitespace preserved for cleanliness).
    var hideWhenRaw = (banner.getAttribute('data-hide-when') || '').trim();
    var showAfterRaw = (banner.getAttribute('data-show-after') || '').trim();

    var hideSelectors, showAfterSelector;
    if (hideWhenRaw || showAfterRaw) {
      hideSelectors = hideWhenRaw
        ? hideWhenRaw.split(',').map(function (s) { return s.trim(); }).filter(Boolean)
        : [];
      showAfterSelector = showAfterRaw || null;
    } else {
      // Legacy fallback — preserves How-It-Works / anxious-flyer behavior.
      hideSelectors = ['.calmsky-how-setup', '#product-closer'];
      showAfterSelector = null;
    }

    var hideNodes = hideSelectors
      .map(function (sel) { return document.querySelector(sel); })
      .filter(Boolean);
    var showAfterNode = showAfterSelector ? document.querySelector(showAfterSelector) : null;

    if (hideNodes.length === 0 && !showAfterNode) return;

    // State: track intersection for each hide sentinel + past-state for the show-after trigger.
    var hideInView = hideNodes.map(function () { return false; });
    // First hide sentinel is treated as "in view" initially in the legacy pair (the hero).
    // For the new selector-driven mode we let the observer fire naturally on observe.
    if (hideWhenRaw === '' && showAfterRaw === '') {
      hideInView[0] = true; // legacy behavior: hero starts in view
    }
    var pastShowAfter = false;

    function updateVisibility() {
      var anyHideInView = hideInView.some(function (v) { return v; });
      var gateOpen = showAfterNode ? pastShowAfter : true;
      if (!anyHideInView && gateOpen) {
        banner.classList.add('is-visible');
        banner.setAttribute('aria-hidden', 'false');
      } else {
        banner.classList.remove('is-visible');
        banner.setAttribute('aria-hidden', 'true');
      }
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var idx = hideNodes.indexOf(entry.target);
        if (idx !== -1) {
          hideInView[idx] = entry.isIntersecting;
          return;
        }
        if (entry.target === showAfterNode) {
          // Consider "past" when the element's top is above the viewport top,
          // i.e. it has scrolled off. isIntersecting=false + top < 0 means past.
          pastShowAfter = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        }
      });
      updateVisibility();
    }, { rootMargin: '-10% 0px -10% 0px', threshold: 0 });

    hideNodes.forEach(function (n) { observer.observe(n); });
    if (showAfterNode) observer.observe(showAfterNode);

    // CTA behavior — either smooth-scroll (default) or add-to-cart.
    var cta = banner.querySelector('[data-landing-sticky-cta]');
    if (!cta) return;

    var ctaMode = (banner.getAttribute('data-cta-mode') || 'scroll').trim();

    if (ctaMode === 'add-to-cart') {
      var bundleId = banner.getAttribute('data-bundle-variant-id') || '';
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        if (!bundleId) {
          window.location.href = '/cart';
          return;
        }
        if (window.CalmSkyCart && typeof window.CalmSkyCart.addItem === 'function') {
          window.CalmSkyCart.addItem(bundleId, 1);
        } else {
          window.location.href = '/cart';
        }
      });
    } else {
      cta.addEventListener('click', function (e) {
        var href = cta.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmsky-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bars = document.querySelectorAll('[data-calmsky-sticky-bar]');
    if (!bars.length) return;
    if (!('IntersectionObserver' in window)) return;

    bars.forEach(function (bar) {
      var section = bar.closest('section');
      if (!section) return;
      var mainCta = section.querySelector('[data-calmsky-add-to-cart], [data-calmsky-add-to-cart-preview]');
      if (!mainCta) return;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bar.classList.remove('is-visible');
            bar.setAttribute('aria-hidden', 'true');
          } else {
            bar.classList.add('is-visible');
            bar.setAttribute('aria-hidden', 'false');
          }
        });
      }, { rootMargin: '-10% 0px -10% 0px' });

      observer.observe(mainCta);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmsky-rating-widget"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var widget = document.querySelector('[data-rating-widget]');
    if (!widget) return;

    var starsContainer = widget.querySelector('[data-rating-stars]');
    var starButtons = Array.prototype.slice.call(
      widget.querySelectorAll('.calmsky-rating-widget__star')
    );
    var thanksEl = widget.querySelector('[data-rating-thanks]');
    var resetBtn = widget.querySelector('[data-rating-reset]');
    var heading = widget.querySelector('.calmsky-rating-widget__heading');

    var STORAGE_KEY = 'calmsky-user-rating';

    function clearHoverClasses() {
      starButtons.forEach(function (b) { b.classList.remove('is-hover'); });
    }

    function clearFilledClasses() {
      starButtons.forEach(function (b) { b.classList.remove('is-filled'); });
    }

    function fillTo(value, className) {
      starButtons.forEach(function (b) {
        var v = parseInt(b.getAttribute('data-rating-value'), 10);
        if (v <= value) b.classList.add(className);
      });
    }

    function renderSubmittedState(value) {
      clearHoverClasses();
      clearFilledClasses();
      fillTo(value, 'is-filled');
      // Disable further clicks
      starButtons.forEach(function (b) {
        b.setAttribute('disabled', '');
        b.style.cursor = 'default';
      });
      if (heading) heading.setAttribute('hidden', '');
      if (thanksEl) {
        var stars = '★'.repeat(value);
        thanksEl.textContent = 'Thanks for the ' + stars + ' rating!';
        thanksEl.removeAttribute('hidden');
      }
      if (resetBtn) resetBtn.removeAttribute('hidden');
    }

    function renderInputState() {
      clearHoverClasses();
      clearFilledClasses();
      starButtons.forEach(function (b) {
        b.removeAttribute('disabled');
        b.style.cursor = '';
      });
      if (heading) heading.removeAttribute('hidden');
      if (thanksEl) {
        thanksEl.setAttribute('hidden', '');
        thanksEl.textContent = '';
      }
      if (resetBtn) resetBtn.setAttribute('hidden', '');
    }

    // On load: check localStorage
    var stored = null;
    try { stored = window.localStorage.getItem(STORAGE_KEY); } catch (e) {}
    if (stored) {
      var storedValue = parseInt(stored, 10);
      if (storedValue >= 1 && storedValue <= 5) {
        renderSubmittedState(storedValue);
      }
    }

    // Hover
    starButtons.forEach(function (btn) {
      btn.addEventListener('mouseenter', function () {
        if (btn.hasAttribute('disabled')) return;
        var value = parseInt(btn.getAttribute('data-rating-value'), 10);
        clearHoverClasses();
        fillTo(value, 'is-hover');
      });
    });

    if (starsContainer) {
      starsContainer.addEventListener('mouseleave', function () {
        clearHoverClasses();
      });
    }

    // Click → submit
    starButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.hasAttribute('disabled')) return;
        var value = parseInt(btn.getAttribute('data-rating-value'), 10);
        try { window.localStorage.setItem(STORAGE_KEY, String(value)); } catch (e) {}
        renderSubmittedState(value);
      });
    });

    // Reset
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) {}
        renderInputState();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmsky-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var track = document.querySelector('[data-reviews-track]');
    var dotsContainer = document.querySelector('[data-reviews-dots]');
    if (!track || !dotsContainer) return;

    var cards = track.querySelectorAll('[data-reviews-card]');
    var dots  = dotsContainer.querySelectorAll('[data-reviews-dot]');
    if (cards.length === 0 || dots.length === 0) return;

    function setActive(index) {
      dots.forEach(function (dot, i) {
        var isActive = i === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    // Observe which card is most visible inside the horizontal scroller.
    // threshold: 0.6 means the card must be >=60% visible to be considered
    // "the active one". Prevents flicker between two half-visible cards.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            var index = Array.prototype.indexOf.call(cards, entry.target);
            if (index !== -1) setActive(index);
          }
        });
      }, {
        root: track,
        threshold: [0.6]
      });
      cards.forEach(function (card) { observer.observe(card); });
    }

    // Clicking a dot snaps the scroll container to the corresponding card.
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var target = cards[i];
        if (!target) return;
        // Use scrollIntoView with 'inline: start' to align the card to the
        // scroll container's start edge — matches the CSS scroll-snap-align
        // declaration on `.calmsky-reviews__card`.
        target.scrollIntoView({
          behavior: 'smooth',
          inline: 'start',
          block: 'nearest'
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmsky-sticky-cta-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var banner = document.querySelector('[data-sticky-cta-banner]');
    if (!banner) return;
    if (!('IntersectionObserver' in window)) return;

    // Selectors: read from data-* attributes if present, else fall back to
    // the legacy How-It-Works / anxious-flyer hardcoded pair. Empty strings
    // count as "not configured" (leading whitespace preserved for cleanliness).
    var hideWhenRaw = (banner.getAttribute('data-hide-when') || '').trim();
    var showAfterRaw = (banner.getAttribute('data-show-after') || '').trim();

    var hideSelectors, showAfterSelector;
    if (hideWhenRaw || showAfterRaw) {
      hideSelectors = hideWhenRaw
        ? hideWhenRaw.split(',').map(function (s) { return s.trim(); }).filter(Boolean)
        : [];
      showAfterSelector = showAfterRaw || null;
    } else {
      // Legacy fallback — preserves How-It-Works / anxious-flyer behavior.
      hideSelectors = ['.calmsky-how-setup', '#product-closer'];
      showAfterSelector = null;
    }

    var hideNodes = hideSelectors
      .map(function (sel) { return document.querySelector(sel); })
      .filter(Boolean);
    var showAfterNode = showAfterSelector ? document.querySelector(showAfterSelector) : null;

    if (hideNodes.length === 0 && !showAfterNode) return;

    // State: track intersection for each hide sentinel + past-state for the show-after trigger.
    var hideInView = hideNodes.map(function () { return false; });
    // First hide sentinel is treated as "in view" initially in the legacy pair (the hero).
    // For the new selector-driven mode we let the observer fire naturally on observe.
    if (hideWhenRaw === '' && showAfterRaw === '') {
      hideInView[0] = true; // legacy behavior: hero starts in view
    }
    var pastShowAfter = false;

    function updateVisibility() {
      var anyHideInView = hideInView.some(function (v) { return v; });
      var gateOpen = showAfterNode ? pastShowAfter : true;
      if (!anyHideInView && gateOpen) {
        banner.classList.add('is-visible');
        banner.setAttribute('aria-hidden', 'false');
      } else {
        banner.classList.remove('is-visible');
        banner.setAttribute('aria-hidden', 'true');
      }
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var idx = hideNodes.indexOf(entry.target);
        if (idx !== -1) {
          hideInView[idx] = entry.isIntersecting;
          return;
        }
        if (entry.target === showAfterNode) {
          // Consider "past" when the element's top is above the viewport top,
          // i.e. it has scrolled off. isIntersecting=false + top < 0 means past.
          pastShowAfter = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        }
      });
      updateVisibility();
    }, { rootMargin: '-10% 0px -10% 0px', threshold: 0 });

    hideNodes.forEach(function (n) { observer.observe(n); });
    if (showAfterNode) observer.observe(showAfterNode);

    // CTA behavior — either smooth-scroll (default) or add-to-cart.
    var cta = banner.querySelector('[data-sticky-cta-banner-cta]');
    if (!cta) return;

    var ctaMode = (banner.getAttribute('data-cta-mode') || 'scroll').trim();

    if (ctaMode === 'add-to-cart') {
      var bundleId = banner.getAttribute('data-bundle-variant-id') || '';
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        if (!bundleId) {
          window.location.href = '/cart';
          return;
        }
        if (window.CalmSkyCart && typeof window.CalmSkyCart.addItem === 'function') {
          window.CalmSkyCart.addItem(bundleId, 1);
        } else {
          window.location.href = '/cart';
        }
      });
    } else {
      cta.addEventListener('click', function (e) {
        var href = cta.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmsky-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function activate(facade) {
      var embedUrl = facade.getAttribute('data-video-embed');
      var title = facade.getAttribute('data-video-title') || 'Customer video review';
      if (!embedUrl) return;

      var iframe = document.createElement('iframe');
      iframe.className = 'calmsky-testimonials__video-iframe';
      iframe.src = embedUrl;
      iframe.title = title + ' — customer video review';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('loading', 'eager');

      facade.innerHTML = '';
      facade.appendChild(iframe);
      facade.removeAttribute('role');
      facade.removeAttribute('tabindex');
      facade.setAttribute('data-activated', 'true');
    }

    function handleClick(event) {
      var facade = event.currentTarget;
      if (facade.getAttribute('data-activated') === 'true') return;
      activate(facade);
    }

    function handleKey(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      var facade = event.currentTarget;
      if (facade.getAttribute('data-activated') === 'true') return;
      activate(facade);
    }

    var facades = document.querySelectorAll('[data-calmsky-video-facade]');
    for (var i = 0; i < facades.length; i++) {
      facades[i].addEventListener('click', handleClick);
      facades[i].addEventListener('keydown', handleKey);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calmsky-user-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var section = document.querySelector('.calmsky-user-reviews');
    if (!section) return;

    // ============================================================
    // Sort dropdown
    // ============================================================
    var sortToggle = section.querySelector('[data-user-reviews-sort-toggle]');
    var sortMenu = section.querySelector('[data-user-reviews-sort-menu]');
    var sortOptions = section.querySelectorAll('[data-sort-key]');
    var reviewList = section.querySelector('[data-user-reviews-list]');
    var reviewCards = Array.prototype.slice.call(
      section.querySelectorAll('[data-review-card]')
    );

    if (sortToggle && sortMenu) {
      sortToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var isHidden = sortMenu.hasAttribute('hidden');
        if (isHidden) {
          sortMenu.removeAttribute('hidden');
          sortToggle.setAttribute('aria-expanded', 'true');
        } else {
          sortMenu.setAttribute('hidden', '');
          sortToggle.setAttribute('aria-expanded', 'false');
        }
      });

      document.addEventListener('click', function (e) {
        if (sortMenu.hasAttribute('hidden')) return;
        if (section.querySelector('[data-user-reviews-sort]').contains(e.target)) return;
        sortMenu.setAttribute('hidden', '');
        sortToggle.setAttribute('aria-expanded', 'false');
      });
    }

    function applySort(key) {
      var sorted = reviewCards.slice();
      if (key === 'featured') {
        sorted.sort(function (a, b) {
          return (
            parseInt(a.getAttribute('data-original-index'), 10) -
            parseInt(b.getAttribute('data-original-index'), 10)
          );
        });
      } else if (key === 'newest') {
        sorted.sort(function (a, b) {
          return b.getAttribute('data-review-date').localeCompare(
            a.getAttribute('data-review-date')
          );
        });
      } else if (key === 'highest') {
        sorted.sort(function (a, b) {
          var starDiff =
            parseInt(b.getAttribute('data-review-stars'), 10) -
            parseInt(a.getAttribute('data-review-stars'), 10);
          if (starDiff !== 0) return starDiff;
          return b.getAttribute('data-review-date').localeCompare(
            a.getAttribute('data-review-date')
          );
        });
      } else if (key === 'lowest') {
        sorted.sort(function (a, b) {
          var starDiff =
            parseInt(a.getAttribute('data-review-stars'), 10) -
            parseInt(b.getAttribute('data-review-stars'), 10);
          if (starDiff !== 0) return starDiff;
          return b.getAttribute('data-review-date').localeCompare(
            a.getAttribute('data-review-date')
          );
        });
      }
      sorted.forEach(function (card) { reviewList.appendChild(card); });
    }

    sortOptions.forEach(function (opt) {
      opt.addEventListener('click', function () {
        var key = opt.getAttribute('data-sort-key');
        sortOptions.forEach(function (o) {
          o.classList.remove('is-active');
          o.setAttribute('aria-checked', 'false');
        });
        opt.classList.add('is-active');
        opt.setAttribute('aria-checked', 'true');
        applySort(key);
        if (sortMenu) {
          sortMenu.setAttribute('hidden', '');
          if (sortToggle) sortToggle.setAttribute('aria-expanded', 'false');
        }
      });
    });

    // ============================================================
    // Modal
    // ============================================================
    var modal = section.querySelector('[data-user-reviews-modal]');
    var openBtn = section.querySelector('[data-user-reviews-open-modal]');
    var closeBtn = section.querySelector('[data-user-reviews-modal-close]');
    var overlay = section.querySelector('[data-user-reviews-modal-overlay]');
    var previouslyFocused = null;

    function openModal() {
      if (!modal) return;
      previouslyFocused = document.activeElement;
      modal.removeAttribute('hidden');
      document.body.classList.add('calmsky-user-reviews-modal-open');
      var firstField = modal.querySelector('input, textarea, button');
      if (firstField) firstField.focus();
    }

    function closeModal() {
      if (!modal) return;
      modal.setAttribute('hidden', '');
      document.body.classList.remove('calmsky-user-reviews-modal-open');
      if (previouslyFocused && previouslyFocused.focus) previouslyFocused.focus();
    }

    if (openBtn) openBtn.addEventListener('click', openModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (overlay) overlay.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) {
        closeModal();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var drawer  = document.querySelector('[data-nav-drawer]');
    var overlay = document.querySelector('[data-nav-drawer-overlay]');
    var button  = document.querySelector('.calmsky-header__menu-btn');
    var closeBtn = document.querySelector('[data-nav-drawer-close]');
    if (!drawer || !overlay || !button) return;

    function onKey(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    }

    function open() {
      // Close cart-drawer defensively — only one drawer open at a time.
      if (window.CalmSkyCart && typeof window.CalmSkyCart.close === 'function') {
        window.CalmSkyCart.close();
      }
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      button.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { closeBtn && closeBtn.focus(); }, 100);
    }

    function close() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      button.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    function toggle() {
      if (drawer.classList.contains('is-open')) close();
      else open();
    }

    closeBtn && closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', onKey);

    // Close drawer on link click before the browser navigates, so on the
    // next page render the drawer is not left in an open state.
    drawer.querySelectorAll('.calmsky-nav-drawer__link').forEach(function (a) {
      a.addEventListener('click', close);
    });

    window.CalmSkyNav = { open: open, close: close, toggle: toggle };
  })();

  } catch(e) { console.error(e); }
})();
})();
